import React from "react";

export const InvitationContext = React.createContext({
  invitedMember: null,
  changeMethod: () => {}
});
